<template>
    <custom-table
        :title="$t('pages.stock.warehouse.shelf.title')"
        :subTitle="$t('pages.stock.warehouse.shelf.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        filterComponentName="CustomerFilter"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange"
    >
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <a v-on:click="fetchShelf(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                         <span class="svg-icon svg-icon-3">
                             <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                         </span>
                    </a>
                </el-tooltip>
                <el-tooltip :content="$t('common.delete')" placement="top">
                    <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                        <template #reference>
                            <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                <span class="svg-icon svg-icon-3">
                                    <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                                </span>
                            </a>
                        </template>
                    </el-popconfirm>
                </el-tooltip>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_shelf" ref="shelfModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_shelf_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form" ref="shelfForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_shelf_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">

                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.stock.warehouse.shelf.cols.name') }}</label>
                                <el-form-item prop="data.name" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.name" type="text"/>
                                </el-form-item>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "shelf",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.stock.warehouse.shelf.cols.id"),
                    key: "id",
                    class: ''
                },
                {
                    name: this.$t("pages.stock.warehouse.shelf.cols.name"),
                    key: "name"
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            form: {},
            selectedRowKeys: [],
            filterParameters: {},
        }
    },
    computed: {
        warehouseId() {
            return this.$route.params.id;
        },
        table() {
            return this.$store.state.stock.warehouse.shelf.table;
        },
        saveData() {
            return this.$store.state.stock.warehouse.shelf.save.data;
        },
        warehouses() {
            return this.$store.state.stock.warehouse.table;
        }
    },
    created() {
        this.resetForm();
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.stock.warehouse.shelf.title"), []);

        this.filterParameters = {
            sort: 'created_at:desc'
        };

        this.$store.dispatch('stock/warehouse/get', {
            page: {
                pageSize: 25,
                current: this.$route.query.page
            },
            filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
        });

        this.refreshTable();
    },
    methods: {
        onSubmit() {
            this.$refs.shelfForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.data.id) {
                        this.$store.dispatch('stock/warehouse/shelf/update', {
                            warehouseId: this.warehouseId,
                            id: this.form.data.id,
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    this.hideModal(this.$refs.shelfModal);
                                    this.refreshTable();
                                });
                            }

                            this.form.loading = false;
                        });
                    } else {
                        this.$store.dispatch('stock/warehouse/shelf/add', {
                            warehouseId: this.warehouseId,
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    this.hideModal(this.$refs.shelfModal);
                                    this.refreshTable();
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        fetchShelf(record) {
            this.form.updateStatus = true;

            this.$store.dispatch('stock/warehouse/shelf/show', {
                id: record.id,
                warehouseId: this.warehouseId,
            }).then(() => {
                let data = this.saveData;

                this.form = {
                    title: this.sprintf(this.$t("pages.stock.warehouse.shelf.editShelfPattern"), [data.name ?? '']),
                    loading: false,
                    data: data
                };

                this.showModal(this.$refs.shelfModal);
            });
        },
        newShelf(record = null) {
            this.resetForm()
            this.form.updateStatus = false;
            this.form.title = this.$t("pages.stock.warehouse.shelf.newShelf");

            if (record) {
                this.form.title = this.sprintf(this.$t("pages.stock.warehouse.shelf.newShelfWithParent"), [record.name]);
            }

            this.showModal(this.$refs.shelfModal);
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.newShelf();
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = filterData

            this.$store.dispatch("stock/warehouse/shelf/get", {
                page: pagination,
                filterData: this.filterParameters,
                warehouseId: this.warehouseId,
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        deleteRecord(id) {
            this.$store.dispatch("stock/warehouse/shelf/delete", {
                id: id,
                warehouseId: this.warehouseId,
            }).then((successDeleted) => {
                this.refreshTable();
            });
        },
        refreshTable() {
            this.$store.dispatch('stock/warehouse/shelf/get', {
                page: {
                    pageSize: 9999,
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({})),
                warehouseId: this.warehouseId,
            });
        },
        resetForm() {
            this.form = {
                title: '',
                loading: false,
                updateStatus: false,
                data: {
                    name: null,
                    warehouse_id: null,
                }
            }
        }
    }
}
</script>

<style scoped>

</style>